<!-- @format -->

@for (node of attainmentNodes; track $index) {
  <div>
    @if (node.type === "AttainmentReferenceNode") {
      @let attainmentReferenceNode = asAttainmentReferenceNode(node);
      <sis-attainment-tree-attainment
        [attainment]="attainmentsById[attainmentReferenceNode.attainmentId]"
        [attainmentsById]="attainmentsById"
        [selectedLocale]="selectedLocale">
      </sis-attainment-tree-attainment>
    }
    @if (node.type === "AttainmentGroupNode") {
      @let attainmentGroupNode = asAttainmentGroupNode(node);
      <sis-attainment-tree-group-node
        [groupingNode]="attainmentGroupNode"
        [attainmentsById]="attainmentsById"
        [selectedLocale]="selectedLocale">
      </sis-attainment-tree-group-node>
    }
  </div>
}
